<template>
  <span>{{ format(display) }}</span>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue';

// Zählt eine Zahl kurz von ihrem alten auf den neuen Wert hoch
const props = withDefaults(defineProps<{ value: number; format?: (v: number) => string; duration?: number }>(), {
  format: (v: number) => String(Math.round(v)),
  duration: 900,
});

const display = ref(0);
let frame = 0;

const animate = (from: number, to: number) => {
  cancelAnimationFrame(frame);
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    display.value = to;
    return;
  }
  const start = performance.now();
  const step = (now: number) => {
    const t = Math.min(1, (now - start) / props.duration);
    const eased = 1 - (1 - t) ** 3;
    display.value = from + (to - from) * eased;
    if (t < 1) frame = requestAnimationFrame(step);
  };
  frame = requestAnimationFrame(step);
};

onMounted(() => animate(0, props.value));
watch(() => props.value, (to, from) => animate(from ?? 0, to));
onUnmounted(() => cancelAnimationFrame(frame));
</script>
